
export enum ApplicationType {
  PSSR = '1500000886',
  MOC = '5041802',
}
